<div class="row justify-content-between pt-2 pb-3" *ngIf="buttonchanger === 'VIDEX'">
  <div class="col-md">
    <label><sup>*</sup>&nbsp;<span i18n>Pflichtfelder</span></label>
    <br/>
    <label><sup>**</sup>&nbsp;<span i18n>Die Bezeichnung "Länder" in dieser Liste umfasst Staaten, Provinzen und Territorien. Sie spiegelt nicht die Position der Bundesregierung hinsichtlich des Status eines Landes oder einer Region wider.</span></label>
  </div>
</div>


<div class="row mt-3 mb-3 justify-content-between" *ngIf="buttonchanger === 'VIDEX'">
  <div class="col-md">
    <button type="button" class="btn btn-danger mb-1"
            style="width: 170px"
            [disabled]="disableButtons"
            (click)="onButtonClicked('reset')"
    ><span i18n>Neuer Antrag</span></button>
  </div>

  <div class="col-md-8 text-end">
    <button type="button" class="btn btn-primary mb-1 me-1"
            style="width: 170px; background-color: #367297"
            [disabled]="disableButtons"
            (click)="onButtonClicked('save')"
    ><span i18n>Speichern</span></button>

    <app-button-with-cooldown
      [attributes]="{
        withTimer: isFormValid(),
        name: 'button.bar-weiterButton1',
        disabled: disableButtons,
        class: isFormValid() ? 'btn btn-primary mb-1' : 'btn btn-stop mb-1',
        labelKey: 'NEXT',
        style: isFormValid() ? {'width': '170px', 'background-color': '#367297'} : {'width': '170px'}
        }"
      (clickHandler)="onButtonClicked(isFormValid() ? 'complete' : 'fehler')"/>
  </div>
</div>

<div class="row mt-3 mb-3 justify-content-between" *ngIf="buttonchanger === 'MEK'">
  <div class="col-md-12">
    <span>
      <button type="button" class="btn btn-danger mb-1" style="width: 150px;"
              (click)="onButtonClicked('back')"
      ><span i18n>Abbrechen</span>
      </button>
    </span>
    <span>
      &nbsp;
    </span>
    <span>
      <button type="button" class="btn btn-danger mb-1" style="width: 150px;"
              (click)="onButtonClicked('reset')"
      ><span i18n>Neuer Antrag</span>
      </button>
    </span>
    <span>
      &nbsp;
    </span>
    <span style="float: right">
      <button appPreventDoubleClick type="button" *ngIf="!isFormValid()"
              class="btn btn-stop"
              style="width: 150px;"
              (throttledClick)="onButtonClicked('fehler')"
      ><span i18n>Abschließen</span></button>
    <button appPreventDoubleClick [throttleTime]="2000" type="button" *ngIf="isFormValid()"
            class="btn btn-primary"
            style="width: 150px;"
            (throttledClick)="onButtonClicked('save')"
    ><span i18n>Abschließen</span></button>
    </span>
  </div>
</div>

<ng-template #neuerAntrag let-c="close">
  <div class="modal-header">
    <h4 class="modal-title" i18n>Eingegebene Daten verwerfen?</h4>
    <button type="button"
            class="modal-close"
            aria-label="Close"
            (click)="c('cancel')"
    ><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    <p style="font-weight: bold" i18n>Wollen Sie wirklich die eingegebenen Daten verwerfen?</p>
  </div>
  <div class="modal-footer">
    <button type="button"
            class="btn btn-danger"
            style="width: 170px"
            (click)="c('cancel')"
    ><span i18n>Abbrechen</span></button>
    <button type="button"
            class="btn btn-primary"
            style="width: 170px; background-color: #367297"
            (click)="c('ok')"
    ><span i18n>OK</span></button>
  </div>
</ng-template>


<ng-template #fehlerAntrag let-c="close">
  <div class="modal-header">
    <h4 class="modal-title" i18n>Es ist ein Fehler aufgetreten.</h4>
    <button type="button"
            class="modal-close"
            aria-label="Close"
            (click)="c('cancel')"
    ><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    <p style="font-weight: bold"
       i18n>Überprüfen Sie bitte Ihre Eingaben. Es wurden nicht alle Pflichtfelder befüllt oder ein Feld wurde nicht korrekt befüllt.</p>
    <p *ngIf="!isValid('angabenZurPerson')" style="margin-bottom: 0.5rem" i18n>Angaben zur Person</p>
    <p *ngIf="!isValid('kontaktdaten')" style="margin-bottom: 0.5rem" i18n>Kontaktdaten</p>
    <p *ngIf="!isValid('ausweispapiere') && appConfig.visumAntragsartEnum === 'LANGFRISTIGER_AUFENTHALT'" style="margin-bottom: 0.5rem"
       i18n>Ausweispapiere</p>
    <p *ngIf="!isValid('ausweispapiere') && appConfig.visumAntragsartEnum === 'KURZFRISTIGER_AUFENTHALT'" style="margin-bottom: 0.5rem"
       i18n="@@Unterlagen">Unterlagen</p>
    <p *ngIf="!isValid('reisedaten')" style="margin-bottom: 0.5rem" i18n>Reisedaten</p>
    <p *ngIf="!isValid('referenz')" style="margin-bottom: 0.5rem" i18n>Referenz</p>
    <p *ngIf="!isValid('kostenuebernahme')" style="margin-bottom: 0.5rem" i18n>Kostenübernahme</p>
    <p *ngIf="validities['kostenuebernahme'] && validities['kostenuebernahme'].validationErrorKeys.indexOf('dritteNichtSpezifiziert') >= 0">
      <span i18n>Bitte prüfen Sie die Angaben im Bereich "Reisekosten und Lebenshaltungskosten": Wenn für die Kostenübernahme "durch Dritte" angegeben wurde, muss mindestens eine der darunter liegenden Optionen gewählt werden.</span>
    </p>
    <p *ngIf="!isValid('zusaetzlicheAngaben')" style="margin-bottom: 0.5rem" i18n>Zusätzliche Angaben</p>
    <p *ngIf="!isValid('lebensunterhaltAufenthaltsdetails')" style="margin-bottom: 0.5rem" i18n>Lebensunterhalt</p>
    <div *ngIf="buttonchanger === 'MEK'">
      <p *ngIf="!isValid('dokumente')" style="margin-bottom: 0.5rem" i18n>Dokumente</p>
      <p *ngIf="!isValid('fingerabdruck') || !isValid('lichtbild')" style="margin-bottom: 0.5rem" i18n>Biometrie</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button"
            class="btn btn-primary"
            style="width: 170px; background-color: #367297"
            (click)="c('ok')"
    ><span i18n>OK</span></button>
  </div>
</ng-template>
